document.addEventListener("DOMContentLoaded", function() {
    const wrapper = document.querySelector('.swipe-wrapper-trusted');
    //let interval = 100; // 100 milliseconds for quicker scrolling
    let totalImages = wrapper.querySelectorAll('img').length;

    // Calculate the total width of a single image as a percentage of the wrapper
    let singleImageWidth = 100 / totalImages; 

    let currentTranslateX = 0;

    function setWrapperTranslate(x) {
        wrapper.style.transform = `translateX(${x}%)`;
    }

    function nextImage() {
        currentTranslateX -= singleImageWidth;
        if (currentTranslateX <= -100) {
            // Resetting the transform to start from the first image again
            currentTranslateX = 0;
        }
        setWrapperTranslate(currentTranslateX);
    }

    setInterval(nextImage, interval);
});
